import type { IInterviewMachineContext } from 'src/machines/shared';
import type { ITxocMachineContext } from 'src/interviews/components/TxocInterview/machine/types';

export const hasInterviewStarted = (context?: IInterviewMachineContext) =>
  context && context?.chatList?.active > 0;

export const hasTxocInterviewCompleted = (context?: ITxocMachineContext) =>
  context?.completion.results?.isComplete;

export const hasInterviewCompleted = (context?: IInterviewMachineContext | ITxocMachineContext) => {
  // NOTE: Completion results for certain interviews like txoc are populated
  if ('isComplete' in (context?.completion.results || {})) {
    return hasTxocInterviewCompleted(context as ITxocMachineContext);
  }
  return !!context?.completion.results;
};
